import React from "react";
import { css } from "emotion";
import { textSizes, colors } from "../../styles/theme";

const BillingTitle = ({ title }) => {
  return <h4 className={container}>{title}</h4>;
};

export default BillingTitle;

const container = css`
  font-size: ${textSizes.subtitle};
  color: ${colors.titleColor};
  letter-spacing: 1px;
`;
